import axios from 'axios';
import { QueryClientProvider, QueryClient } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import { changeAxiosUrl, updateAxiosHeader } from 'utils/axios';

import { AuthenticatedContextProvider } from 'hooks/useAuthenticated';
import { ThemeProvider } from 'styles/styledComponents';
import { TranslationsProvider } from 'translations';

import App from './App';

// co to tu robi? bo co strzelamy do https://code-standards.azurewebsites.net/api
// axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
changeAxiosUrl();
updateAxiosHeader();

const queryClient = new QueryClient();

function AppContainer() {
  return (
    <RecoilRoot>
      <TranslationsProvider>
        <BrowserRouter>
          <QueryClientProvider client={queryClient}>
            <ThemeProvider>
              <AuthenticatedContextProvider>
                <App />
              </AuthenticatedContextProvider>
            </ThemeProvider>
          </QueryClientProvider>
        </BrowserRouter>
      </TranslationsProvider>
    </RecoilRoot>
  );
}

export default AppContainer;
